import { createSelector } from 'reselect'

export const getObservers = (state, props) => {
  return state['view-card'].observers[props.cardContext.id]
}

export default createSelector(
  [
    getObservers
  ],
  (
    observers
  ) => ({
    observers
  })
)
